import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Forbidden = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  const goBack = () => navigate(-1);
  const goDashboard = () => navigate("/dashboard");

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(interval);
          navigate("/dashboard");
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [navigate]);

  const styles = {
    page: {
      height: "100vh",
      background: "#f4f6f9", // same as your dashboard background
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },

    card: {
      background: "#ffffff",
      padding: "50px",
      borderRadius: "12px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
      textAlign: "center",
      width: "400px",
    },

    code: {
      fontSize: "72px",
      margin: "0",
      color: "#0d1b4c", // sidebar blue
      fontWeight: "bold",
    },

    title: {
      margin: "10px 0",
      color: "#333",
    },

    text: {
      color: "#666",
      marginBottom: "15px",
    },

    countdown: {
      color: "#444",
      marginBottom: "25px",
    },

    highlight: {
      color: "#007bff",
      fontWeight: "bold",
    },

    buttonContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "10px",
    },

    primaryBtn: {
      background: "#007bff",
      color: "#fff",
      border: "none",
      padding: "10px 20px",
      borderRadius: "6px",
      cursor: "pointer",
    },

    secondaryBtn: {
      background: "#e0e0e0",
      color: "#333",
      border: "none",
      padding: "10px 20px",
      borderRadius: "6px",
      cursor: "pointer",
    },
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.code}>403</h1>
        <h2 style={styles.title}>Access Denied</h2>

        <p style={styles.text}>
          You don't have permission to access this page.
        </p>

        <p style={styles.countdown}>
          Redirecting to dashboard in{" "}
          <span style={styles.highlight}>{countdown}</span> seconds...
        </p>

        <div style={styles.buttonContainer}>
          <button style={styles.secondaryBtn} onClick={goBack}>
            Go Back
          </button>

          <button style={styles.primaryBtn} onClick={goDashboard}>
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default Forbidden;